module.exports = __webpack_public_path__ + "img/e-Tensil-440x211-1.4bc199b6.jpg";